import { Component, ChangeDetectionStrategy, input, computed, inject, output, signal } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { CommonModule } from '@angular/common';
import { EtiquetteStoreService } from '../../services/etiquette-service/etiquette-store.service';
import { Etiquette } from '../../models/etiquette.model';
import { FormsModule } from '@angular/forms';
import { InputText } from "primeng/inputtext"

@Component({
  selector: 'spike-etiquette-list',
  templateUrl: './etiquette-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule, InputText]
})
export class EtiquetteListComponent extends AbstractComponent {
  public readonly etiquetteStoreService = inject(EtiquetteStoreService);
  list = input.required<Etiquette[]>();
  onSelect = output<Etiquette>();
  public filter = signal<string>('');

  public readonly filteredList = computed(()=>{
    const list = this.list();
    const filter = this.filter();
    return list.filter(x=> x.shortDescription.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) );
  })

  private debounceTimeout?: any;
  updateFilter(searchKey: string) {
    console.log(searchKey)
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.filter.set(searchKey);
    }, 300);

  }
  

}